import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["apiKey", "apiKeyField", "status", "form", "oauthButton", "clear", "label"]

  connect() {
    this.updateState()
  }

  updateState() {
    this.#updateLabel()

    // Only auto OAuth2 schemes collapse the form once the token is
    // filled: other schemes keep the API key input always displayed.
    if (this.#isAutoOauth2() && this.#isFilled()) {
      this.#close()
    } else {
      this.#edit()
    }
  }

  clear() {
    // 1. clear api key field value
    this.apiKeyTarget.value = ""
    // 2. Simulate user input for other events to bubble up (store key in
    // local storage, update UI, etc..)
    this.apiKeyTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.#edit()
  }

  highlightForm() {
    this.element.dataset.formHighlight = true

    setTimeout(() => {
      delete this.element.dataset.formHighlight
    }, 1000)
  }

  #close() {
    // Hide form and “Get token” button
    this.formTarget.setAttribute("aria-hidden", true)
    this.oauthButtonTarget.setAttribute("aria-hidden", true)

    // Display status and action button
    this.statusTarget.setAttribute("aria-hidden", false)
    this.clearTarget.setAttribute("aria-hidden", false)
  }

  #edit() {
    // Display form
    this.formTarget.setAttribute("aria-hidden", false)

    const isAutoOauth2 = this.#isAutoOauth2()
    // Different state based on security scheme type
    this.apiKeyFieldTarget.hidden = isAutoOauth2
    this.oauthButtonTarget.setAttribute("aria-hidden", !isAutoOauth2)

    // Hide status and action button
    this.statusTarget.setAttribute("aria-hidden", true)
    this.clearTarget.setAttribute("aria-hidden", true)
  }

  #isFilled() {
    const apiKey = this.apiKeyTarget.value.trim()
    return apiKey.length > 0
  }

  #isAutoOauth2() {
    const authenticationScheme = this.#selectedAuthenticationScheme()

    if (authenticationScheme) {
      return !!(authenticationScheme.dataset.oauth?.grantType || JSON.parse(authenticationScheme.dataset.oauth)?.grantType)
    } else {
      return false
    }
  }

  #selectedAuthenticationScheme() {
    return this.element.querySelector("[data-selected-scheme=true]")
  }

  #updateLabel() {
    if (this.hasLabelTarget) {
      this.labelTarget.innerText = this.#selectedAuthenticationScheme().dataset.schemeLabel || ""
    }
  }
}
